import * as Yup from 'yup';
import {getSelectItemLabel} from '~/components/Controls/Select';
import {ID, IModel} from '~/lib/model';

export enum BlockingType {
    CAT = 'cat',
    ADV = 'adv',
    APP = 'app',
    CID = 'cid+crid'
}

export const blockingTypes: { value: BlockingType; label: string }[] = [
    {value: BlockingType.CAT, label: 'Categories'},
    {value: BlockingType.ADV, label: 'Advertisers'},
    {value: BlockingType.APP, label: 'Apps'},
    {value: BlockingType.CID, label: 'CreativeId'}
];

export const getBlockingTypesLabel = (blockingType: BlockingType) =>
    getSelectItemLabel(blockingTypes, blockingType);

export enum BlockingAgencyMode {
    ALL = 'all',
    INCLUDE = 'include',
    EXCLUDE = 'exclude'
}

export interface IBlocking extends IModel {
    id: ID;
    reason?: string;
    sellerId: ID;
    agencyIds: ID[];
    includesAgencies: boolean;
    blockingType: BlockingType;
    bundles?: string[] | string;
    blockingValues?: string[] | string;
    agencyMode?: BlockingAgencyMode;
}

export const BlockingSchema = Yup.object().shape<IBlocking>({
    id: Yup.number().nullable(),
    reason: Yup.string().nullable(),
    sellerId: Yup.number().required().nullable(),
    agencyIds: Yup.array<number>(),
    includesAgencies: Yup.boolean(),
    agencyMode: Yup.mixed<BlockingAgencyMode>()
        .oneOf(Object.values(BlockingAgencyMode)),
    blockingType: Yup.mixed().required().nullable(),
    bundles: Yup.array<string>().nullable(),
    blockingValues: Yup.array<string>().nullable()
});

export const defaultBlocking: IBlocking = {
    id: null,
    reason: '',
    sellerId: null,
    agencyIds: [],
    includesAgencies: true,
    blockingType: null,
    bundles: '',
    blockingValues: [],
    agencyMode: BlockingAgencyMode.ALL
};
